import React from 'react';
import { Menu } from 'antd';

function KeyMenuItem(key, itemName, click) {
  return (
    <Menu.Item className="via-menu-link-override" key={key} onClick={click}>
      {itemName}
    </Menu.Item>
  );
}

export default KeyMenuItem;
